export const mondayAbbreviatedLowercase = "xra";
export default {mondayAbbreviatedLowercase};